export default __webpack_public_path__ + "fonts/iconfont.97f23da02a7ca2bca88a6e204a22046c.svg";